import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=94b12caa&"
import script from "./CompanyLogo.vue?vue&type=script&lang=js&"
export * from "./CompanyLogo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLogo.vue?vue&type=style&index=0&id=94b12caa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports